import useClientState from '@/state/useClientState';

/** @deprecated Create view/component based hooks. */
const useSelectedStore = () => {
  const isMultiSelect = useClientState((state) => state.selected.isMultiSelect);
  const selectedDeeltrajecten = useClientState((state) => state.selected.deeltrajecten);
  const selectedWerklijnen = useClientState((state) => state.selected.werklijnen);
  const selectedOvergangen = useClientState((state) => state.selected.overgangen);
  const selectedItems = useClientState((state) => state.selected.selectedItems);
  return {
    isMultiSelect,
    selectedDeeltrajecten,
    selectedWerklijnen,
    selectedOvergangen,
    selectedItems,
  };
};
export default useSelectedStore;
